import { requiredOptions, requiredString } from "../utils/validations";
export const validators = {
    name: (_template, value) => requiredString(value),
    dimensions: (_template, value) => requiredOptions(value),
    metrics: (_template, value) => requiredOptions(value)
};
//# sourceMappingURL=validators.js.map